import { type AnnotationLabel, ANNOTATION_LABEL_TYPE } from '../types/annotation-label';

/**
 * Returns the display name for a label, optionally including a counter.
 * Speech labels include the counter (e.g., "Speaker 1"), while non-speech labels do not (e.g., "Noise").
 *
 * @param label - The annotation label
 * @param counter - The counter number for this annotation instance
 * @returns The formatted label display name
 */
export const getLabelDisplayName = (label: Pick<AnnotationLabel, 'title' | 'type'>, counter: number): string => {
  const isSpeechLabel = label.type === ANNOTATION_LABEL_TYPE.SPEECH_LABEL;
  return isSpeechLabel ? `${label.title} ${counter}` : label.title;
};

/**
 * @param label - The annotation label
 * @param counter - The counter number for this annotation instance
 * @param slotIndex - The index of the slot
 * @returns The formatted label display name for the slot
 */
export const getAnnotationSlotLabelDisplayName = (label: Pick<AnnotationLabel, 'title' | 'type'>, counter: number, slotIndex: number): string => {
  const labelDisplayName = getLabelDisplayName(label, counter);
  return `${labelDisplayName} - Slot ${slotIndex + 1}`;
};
export const getSlotLabelDisplayName = (labelDisplayName: string, slotIndex: number): string => {
  return `${labelDisplayName} - Slot ${slotIndex + 1}`;
};